import { getSignedInViewerDetailsOrDefault } from 'auth';
import { useService } from 'envoc-request';

export default function XsrfToken() {
  useService(getSignedInViewerDetailsOrDefault);

  return null;
}
